module.exports = __webpack_public_path__ + "static/img/1.8f59e5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/right/1.png
// module id = 7kgn
// module chunks = 25